<!-- Loading Overlay -->
  <div *ngIf="isLoading" class="loading-overlay">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>{{ 'common.loading' | translate }}</p>
  </div>
</div>

<main class="main-content">

    <!-- Table View -->
    <div *ngIf="!hasFatalError && isTableView" class="table-container fullscreen">
      <!-- Table Header with Options -->
      <div class="table-header">
        <h3 class="table-title">{{ 'dashboard.table.title' | translate }}</h3>
        <div class="table-options">
          <button class="options-btn" (click)="toggleColumnSelector()" [class.active]="showColumnSelector">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M3 12h18M3 18h18" [attr.stroke]="showColumnSelector ? '#1e40af' : '#666'" stroke-width="2" stroke-linecap="round"/>
            </svg>
            {{ 'dashboard.table.columns' | translate }}
          </button>
        </div>
      </div>

      <!-- Column Selector -->
      <div class="column-selector" [class.visible]="showColumnSelector">
        <div class="selector-header">
          <h4>{{ 'dashboard.table.selectOption' | translate }}</h4>
          <label class="select-all">
            <input type="checkbox" (change)="selectAllColumns()" [checked]="areAllColumnsSelected()">
            {{ 'dashboard.table.selectAll' | translate }}
          </label>
        </div>
        <div class="selector-options">
          <label><input type="checkbox" [(ngModel)]="columnVisibility.source" (change)="onColumnVisibilityChange()"> {{ 'dashboard.table.options.source' | translate }}</label>
          <label><input type="checkbox" [(ngModel)]="columnVisibility.device" (change)="onColumnVisibilityChange()"> {{ 'dashboard.table.options.device' | translate }}</label>
          <label><input type="checkbox" [(ngModel)]="columnVisibility.goal" (change)="onColumnVisibilityChange()"> {{ 'dashboard.table.options.goal' | translate }}</label>
        </div>
      </div>

      <table class="data-table">
        <thead>
          <tr>
            <th *ngIf="columnVisibility.audience">{{ 'dashboard.table.headers.audiences' | translate }}</th>
            <th *ngIf="columnVisibility.source">{{ 'dashboard.table.headers.sources' | translate }}</th>
            <th *ngIf="columnVisibility.device">{{ 'dashboard.table.headers.device' | translate }}</th>
            <th *ngIf="columnVisibility.goal">{{ 'dashboard.table.headers.goalType' | translate }}</th>
            <th *ngIf="columnVisibility.users">{{ 'dashboard.table.headers.users' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of expandedRows; let i = index" [class.row-group-start]="row.audience !== ''">
            <td *ngIf="columnVisibility.audience" class="audience-cell" [class.audience-label]="row.audience !== ''">{{row.audience}}</td>
            <td *ngIf="columnVisibility.source">{{row.source}}</td>
            <td *ngIf="columnVisibility.device">{{row.device}}</td>
            <td *ngIf="columnVisibility.goal">{{row.goal}}</td>
            <td *ngIf="columnVisibility.users" class="users-cell">
              <div class="progress-container">
                <div class="progress-bar" [style.width.%]="row.userProgress"></div>
                <span class="progress-text">{{row.userCount | number}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Chart View -->
    <div *ngIf="!hasFatalError && !isTableView" class="dashboard-grid" [class.loading]="isLoading">
      <ng-container *ngIf="!dataError">
        <div class="chart-container total-users chart-has-tooltip">
          <div class="chart-header">
            <h3>
              {{ 'dashboard.charts.totalUsers' | translate }}
              <span
                class="info-hint"
                role="img"
                tabindex="0"
                [attr.aria-label]="'dashboard.tooltips.totalUsers' | translate"
                [attr.data-tooltip]="'dashboard.tooltips.totalUsers' | translate">ℹ</span>
            </h3>
            <div class="chart-value">
              <div class="value-container">
                <span class="value">##.###</span>
                <span class="percentage">+#.#%</span>
              </div>
            </div>
          </div>
          <div class="chart-content">
            <canvas id="totalUsersChart"></canvas>
            <div class="no-data-overlay" *ngIf="!totalUsersHasData">
              <span>{{ 'common.noData' | translate }}</span>
            </div>
          </div>
        </div>

        <div class="chart-container users-category chart-has-tooltip">
          <div class="chart-header">
            <h3>
              {{ 'dashboard.charts.enrichedUsers' | translate }}
              <span
                class="info-hint"
                role="img"
                tabindex="0"
                [attr.aria-label]="'dashboard.tooltips.enrichedUsers' | translate"
                [attr.data-tooltip]="'dashboard.tooltips.enrichedUsers' | translate">ℹ</span>
            </h3>
          </div>
          <div class="chart-content">
            <canvas id="usersCategoryChart"></canvas>
          </div>
        </div>

        <div class="chart-container audience-cards">
          <div class="audience-strip" [class.empty]="!treemapHasData">
            <div class="audience-pill"
                 *ngFor="let card of audienceCards; let i = index"
                 [style.background-color]="card.color"
                 [style.color]="card.textColor">
              <span class="audience-pill__name">{{ card.name }}</span>
              <span class="audience-pill__value" [style.color]="card.textColor">{{ card.value }}</span>
              <span class="audience-pill__percentage" [style.color]="card.textColor">{{ card.percentage }}</span>
            </div>
            <div class="no-data-overlay" *ngIf="!treemapHasData">
              <span>{{ 'common.noData' | translate }}</span>
            </div>
          </div>
        </div>

        <div class="chart-container users-device chart-has-tooltip">
          <div class="chart-header">
        <h3>
          {{ 'dashboard.charts.usersByMetric' | translate:{ metric: (selectedDeviceMetricLabel | translate) } }}
          <span
            class="info-hint"
            role="img"
            tabindex="0"
            [attr.aria-label]="'dashboard.tooltips.usersByDevice' | translate"
            [attr.data-tooltip]="'dashboard.tooltips.usersByDevice' | translate">ℹ</span>
        </h3>
            <div class="device-selector">
              <select (change)="onDeviceMetricChange($any($event.target).value)" [value]="selectedDeviceMetric">
                <option *ngFor="let metric of availableDeviceMetrics" [value]="metric.id">
                  {{ metric.name | translate }}
                </option>
              </select>
            </div>
          </div>
          <div class="chart-content">
            <div class="chart-with-legend">
              <div class="chart-wrapper">
                <canvas id="usersDeviceChart" width="200" height="200"></canvas>
              </div>
              <div class="device-legend" *ngIf="usersDeviceLegend.length">
                <div class="legend-item" *ngFor="let entry of usersDeviceLegend">
                  <span class="legend-color" [style.background-color]="entry.color"></span>
                  <span class="legend-text" [title]="entry.label">{{ entry.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="chart-container users-audience chart-has-tooltip">
          <div class="chart-header">
            <h3>
              {{ 'dashboard.charts.publicBreakdown' | translate }}
              <span
                class="info-hint"
                role="img"
                tabindex="0"
                [attr.aria-label]="'dashboard.tooltips.publicBreakdown' | translate"
                [attr.data-tooltip]="'dashboard.tooltips.publicBreakdown' | translate">ℹ</span>
            </h3>
          </div>
          <div class="chart-content">
            <canvas id="usersAudienceChart"></canvas>
          </div>
        </div>
      </ng-container>
    </div>

  <div *ngIf="hasFatalError" class="dashboard-error fullscreen">
    <h3>{{ 'dashboard.status.errorTitle' | translate }}</h3>
    <p>{{ dataErrorMessage || ('dashboard.status.errorDescription' | translate) }}</p>
    <button *ngIf="canRetry" type="button" class="retry-button" (click)="retryLoad()">
      {{ 'common.retry' | translate }}
    </button>
  </div>

  <div class="bottom-icons" *ngIf="!hasFatalError">
    <div class="icon-item" [class.active]="isTableView" (click)="toggleTableView()"
         [title]="(isTableView ? 'common.showChartsView' : 'common.showTableView') | translate">
      <!-- In table view mostra l'icona dei grafici (click per tornare ai grafici) -->
      <svg *ngIf="isTableView" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <line x1="4" y1="20" x2="20" y2="20" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="5" y1="20" x2="5" y2="11" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="10" y1="20" x2="10" y2="5" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="15" y1="20" x2="15" y2="9" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="20" y1="20" x2="20" y2="14" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <!-- In chart view mostra l'icona della tabella -->
      <svg *ngIf="!isTableView" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="#666" stroke-width="2" fill="none"/>
        <line x1="9" y1="9" x2="15" y2="9" stroke="#666" stroke-width="2"/>
        <line x1="9" y1="15" x2="15" y2="15" stroke="#666" stroke-width="2"/>
        <line x1="3" y1="9" x2="21" y2="9" stroke="#666" stroke-width="2"/>
      </svg>
      <span [style.color]="isTableView ? '#1e40af' : '#666'">{{ (isTableView ? 'common.charts' : 'common.table') | translate }}</span>
    </div>

    <div class="icon-item" (click)="exportToPNG()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <polyline points="14,2 14,8 20,8" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="16" y1="13" x2="8" y2="13" stroke="#666" stroke-width="2" stroke-linecap="round"/>
        <line x1="16" y1="17" x2="8" y2="17" stroke="#666" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>{{ 'common.png' | translate }}</span>
    </div>

    <div class="icon-item" (click)="exportToExcel()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <polyline points="14,2 14,8 20,8" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 13h6v4H9z" stroke="#666" stroke-width="1" fill="#666"/>
      </svg>
      <span>{{ 'common.xls' | translate }}</span>
    </div>

  </div>
</main>
